export default __webpack_public_path__ + "sample/12-half-line-and-vector.xml";